import React from 'react';
import { Result, Button } from 'antd';

export default () => (
  <Result
    status="403"
    title="403"
    subTitle="对不起，您无权访问该页面。"
    extra={
      <Button type="primary">
        返回首页
      </Button>
    }
  ></Result>
);
